<template>
    <br />
    <van-card v-for="(ProductVo, id) in productList.ProductVo" :key="id" :title="ProductVo.productName"
        :thumb="ProductVo.img" :price="ProductVo.personFee" :origin-price="ProductVo.allFee" :tag="ProductVo.tag"
        @click="findData(ProductVo.productCode)">
        <template #desc>
            <div>
                <p class="text3DIndentation">产品包含：</p>
                <p class="text2DIndentation">{{ ProductVo.descOne }}</p>
                <p class="text2DIndentation">{{ ProductVo.descTwo }}</p>
                <p class="text2DIndentation">{{ ProductVo.descThree }}</p>
                <p class="text2DIndentation">{{ ProductVo.descFour }}</p>
                <p class="text2DIndentation">{{ ProductVo.descFive }}</p>
                <p class="text3DIndentation"> 绑定机构：{{ ProductVo.hospName }}</p>
            </div>
        </template>
        <template #footer>
            <van-button size="small">详情</van-button>
        </template>
    </van-card>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
        <div class="wrapper" @click.stop>
            <div class="block">
                <van-cell-group inset>
                    <van-notice-bar wrapable :scrollable="false" text="异常提醒" left-icon="info-o" />
                    <p class="textIndentation">
                        <van-notice-bar wrapable :scrollable="false" color="#1989fa" background="#ffffff">{{ bingingNotice
                        }}</van-notice-bar>
                    </p>
                    <van-button v-if="goToUserInfo" type="warning" block plain hairline to="bindingHosp">
                        开始绑定
                    </van-button>
                    <van-button v-if="goToAbout" type="warning" block plain hairline to="about">
                        返回项目介绍
                    </van-button>
                </van-cell-group>
            </div>
        </div>
    </van-overlay>
</template>
<script>
import { ref, reactive, onMounted } from 'vue';
import { getProductList } from '../../api/personOrder'
import { getCheckBinding,getCheckBaseRiskInfo } from '../../api/permission'
import { showConfirmDialog } from 'vant';
import { useRouter } from 'vue-router';
import { postUserLog } from "../../api/userlog";
export default {
    setup() {
        const router = useRouter();
        const showCorporatePay = ref('false');
        const originPrice = ref('');
        const bingingNotice = ref('');
        const showOverlay = ref(false);
        const showBinging = ref(false);
        const goToUserInfo = ref(false);
        const goToAbout = ref(false);
        const ulog = reactive({
            UserLog: {
                 path: "",
            },
        });
        const productList = reactive({
            ProductVo: {
                id: '',
                productCode: '',
                productName: '',
                descOne: '',
                descTwo: '',
                descThree: '',
                descFour: '',
                descFive: '',
                hospId: '',
                hospName: '',
                personFee: '',
                allFee: '',
                corporatePay: '',
                img: '',
                tag: '',
                operation: '',
                isCorporate: '',
            }
        })
        onMounted(() => {
            ulog.UserLog.path = router.currentRoute.value.fullPath;
            console.log("当前页面路径==" + ulog.UserLog.path);
            postUserLog(ulog.UserLog).then(() => {});
            getCheckBinding().then((res1) => {
                console.log(res1.data.code);
                const binding = res1.data.code;
                if (binding == 60002) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定进度未完成】：我们会在1～3个工作日内完成";
                    goToAbout.value = true;
                } else if (binding == 60000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定异常】：早知心，目前仅开放体检机构侧邀约指定客户绑定。您可以向体检机构获取【邀请码】";
                    goToUserInfo.value = true;
                } else if (binding == 40000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【登陆异常】：请您在微信端打开";
                    goToAbout.value = true;
                } else {
                    getCheckBaseRiskInfo().then((res) => {
                        console.log(res.data.code);
                        const baseRiskOk = res.data.code;
                        if (baseRiskOk == 0) {
                            console.log("弹窗");
                            showConfirmDialog({
                                title: '【待处理】事项',
                                message:
                                    '系统识别到您还未做检查前的个人自评，需要您先进行自评。\n点击确认，立即开始',
                                })
                                .then(() => {
                                    router.push('/personAction');
                                })
                            .catch(() => {
                                    router.push('/about');
                            });
                        } else {
                            getProductList().then((res) => {
                                 productList.ProductVo = res.data.data;
                                 console.log(res.data.data);
                            if (productList.isCorporate == 1) {
                                 showCorporatePay.value = true;
                                 }
                            })
                        }
                    })
                }
            })

        })

        return {
            showOverlay,
            showBinging,
            bingingNotice,
            goToUserInfo,
            goToAbout,
            productList,
            showCorporatePay,
            originPrice
        }
    },
    methods: {
        findData(id) {
            this.$router.push('/productDes/' + id)
        }
    }
}

</script>
<style scoped>
/* 调整图像大小(最好用百分比) */
.van-card-img {
    width: 40% !important;
    height: 40% !important;
}

.text2DIndentation {
    font-size: 12px;
    text-align: left;
    margin-left: 2em;
}

.text3DIndentation {
    font-size: 12px;
    text-align: left;
    text-indent: 1em;
}
</style>
